"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const intl_1 = require("@kyruus/intl");
const button_1 = __importDefault(require("@kyruus/button"));
const messages_1 = __importDefault(require("../../lib/messages"));
const styles_1 = require("./styles");
const variants = {
    initial: { opacity: 0, scale: 0.1 },
    enter: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.1 }
};
const NextBtn = react_1.default.forwardRef(({ onClick, type = '', form = '' }, ref) => {
    return (react_1.default.createElement(styles_1.NextBtnContainer, { style: { display: 'inline-block' }, "data-testid": "NextBtn", key: "apptinfo-next-btn", variants: variants, initial: "initial", animate: "enter", exit: "exit" },
        react_1.default.createElement(button_1.default, { ref: ref, mode: "primary", onClick: onClick, type: type, form: form },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.next)))));
});
NextBtn.displayName = 'NextBtn';
NextBtn.propTypes = {
    onClick: prop_types_1.default.func.isRequired,
    type: prop_types_1.default.string,
    form: prop_types_1.default.string
};
exports.default = NextBtn;
//# sourceMappingURL=NextBtn.js.map